import { useQuery } from "@tanstack/react-query"
import type { MembershipListResponse } from "@zplanem/responses"
import { apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

export function usePropertyMemberships(propertyId: string | undefined) {
	return useQuery({
		queryKey: propertyId
			? queryKeys.propertyMemberships(propertyId)
			: ["properties", "__nil__", "memberships"],
		queryFn: () =>
			apiFetch<MembershipListResponse>(
				`/api/common/properties/${propertyId}/memberships`,
			),
		enabled: !!propertyId,
		// Cached forever; the server publishes `membership.changed` on the
		// per-property realtime channel and `usePropertyChannelInvalidators`
		// invalidates this query on receipt.
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
	})
}
